function utils(shacl, entailments, getLoadedChannels, internalContext) {

	function getShapes(resourceIRI, graphIRI) {
		const id = graphIRI + "___" + resourceIRI;
		const channelType = getLoadedChannels()[id].type;
		const classTypes = Array.isArray(channelType) ? channelType : [channelType];
		const classIRIs = classTypes.map(classType => {
			if (classType.startsWith("http")) return classType;
			return internalContext._context.byProperty[classType];
		});
		const shapes = shacl.filter(entry => classIRIs.includes(entry.targetClass));
		return shapes;
	}

	/**
	 * The contract for this function needs to match the corresponding function on the server
	 * because common code uses different versions of the function
	 * @param {*} resourceIRI 
	 * @param {*} graphIRI 
	 * @param {*} predicate 
	 */
	function isUniqueLang(resourceIRI, graphIRI, predicate) {
		const shapes = getShapes(resourceIRI, graphIRI);
		if (!shapes) return false;
		let isUnique = false;
		// If any of the class shapes define it is as unique it is unique
		shapes.forEach(shape => {
			const property = shape.property.find(entry => entry.path === predicate);
			if (property && property.uniqueLang && property.uniqueLang === "true") isUnique = true;
		});
		return isUnique;
	}

	function isFunctional(resourceIRI, graphIRI, predicate, clientPredicateGraphIRI, serverPredicateGraphIRI) {
		const predicateId = clientPredicateGraphIRI + "___" + predicate;
		if (clientPredicateGraphIRI && clientPredicateGraphIRI === serverPredicateGraphIRI) {
			if (getLoadedChannels()[predicateId]) {
				const predicateType = getLoadedChannels()[predicateId].type;
				const predicateclassTypes = Array.isArray(predicateType) ? predicateType : [predicateType];
				if (predicateclassTypes.includes("FunctionalProperty")) {
					return true;
				}
			}
		}
		const shapes = getShapes(resourceIRI, graphIRI);
		if (!shapes) return false;
		let isFunctional = false;
		// If any of the class shapes define it is as functional it is functional
		shapes.forEach(shape => {
			const property = shape.property.find(entry => entry.path === predicate);
			if (property && property.maxCount && property.maxCount === "1") isFunctional = true;
		});
		return isFunctional;
	}

	/*	function isDisjoint(predicate1, predicate2) {
		const shape = shacl.find(entry => entry.targetClass === classIRI);
		if (!shape) return false;
		const property = shape.property.find(entry => {
			return entry.path === predicate1
		});
		if (!property) return false;
		return property.disjoint && property.disjoint.includes(predicate2);
	}*/

	function isEntailedPredicate(predicate) {
		const canBeEntailed = entailments.find(entry => entry.subPropertyOf === predicate);
		return canBeEntailed;
	}

	function isEntailedPredicatePair(predicateA, predicateB) {
		const canBeEntailed = entailments.find(entry => entry.subPropertyOf === predicateA);
		if (!canBeEntailed || canBeEntailed.length === 0) return null;
		// For each chain we check whether predicateB is the first item in the chain
		// We only check the first item because only the first can be on the same resource
		// If it is an operation on one of those predicates it could cause an entailment
		const isEntailedChain = canBeEntailed.propertyChain[0] === predicateB;
		if (!isEntailedChain) return null;
		// We return the entailing predicate
		return canBeEntailed.propertyChain[1];
	}

	function computeResourceState(secondPredicateIRI, middleResourceIRI, graphIRI) {
		const id = graphIRI + "___" + middleResourceIRI;
		const data = getLoadedChannels()[id];
		if (data) {
			const property = internalContext._context.byIRI[secondPredicateIRI];
			// Does this object contain the nth item in the chain?
			if (data[property]) {
				// Assuming language container
				const result = [];
				Object.keys(data[property]).forEach(lang => {
					const langData = Array.isArray(data[property][lang]) ? data[property][lang] : [data[property][lang]];
					langData.forEach(langValue => {
						result.push({
							resource: langValue,
							lang: lang
						});
					});
				});
				return result;
			}
		}
		return null;
	}

	// We only need to do forward entailement. We're essentially trying to find out if any inserted resource can entail a value
	// Again we only handle two level chains for now, which is sufficient for SKOS
	function computeEntailment(predicateURI, objectValue, subProperty, graphIRI) {
		let results = entailments
			.filter(em => em.subPropertyOf === subProperty && em.propertyChain[0] === predicateURI)
			.map(em => {
				// We haven't actually added the first item in the chain yet, we're checking for entailment IF we do.
				// So we find chains that match if we added and start from the objectValue resource for the rest of the chain
				return processChainItem(objectValue, [em.propertyChain[1]], graphIRI);
			});
		return results;
	}

	// Only works for property chains of length 2 at the moment which means we're only checking one level more
	// It's also important that the client doing the inferencing has the resource loaded to be able to do the inference
	function processChainItem(resourceIRI, chain, graphIRI) {
		const id = graphIRI + "___" + resourceIRI;
		const data = getLoadedChannels()[id];
		if (data) {
			const chainMember = chain[0];
			const property = internalContext._context.byIRI[chainMember];
			// Does this object contain the nth item in the chain?
			if (data[property]) {
				return data[property];
			}
		}
		else return null;
	}

	return {
		isUniqueLang,
		isFunctional,
		processChainItem,
		computeEntailment,
		isEntailedPredicate,
		isEntailedPredicatePair,
		computeResourceState
	};
}

export default utils;